import { selectViewState } from "views/logic/slices/viewSelectors";
import { updateViewState } from "views/logic/slices/viewSlice";
import { selectTitles } from "views/logic/slices/titlesSelectors";
export const updateTitles = (id, newTitles) => async (dispatch, getState) => {
  const viewState = selectViewState(id)(getState());
  const newViewState = viewState.toBuilder().titles(newTitles).build();
  return dispatch(updateViewState(id, newViewState));
};
export const setTitle = (queryId, type, id, title) => async (dispatch, getState) => {
  const viewState = selectViewState(queryId)(getState());
  const titles = selectTitles(queryId)(getState());
  const newTitles = titles.setIn([type, id], title);
  const newViewState = viewState.toBuilder().titles(newTitles).build();
  return dispatch(updateViewState(queryId, newViewState));
};
